/**
* @Author: 858834013@qq.com
* @Name: titleInfo
* @Date: 2022-08-24
* @Desc:
*/
<template>
  <div class="itemTitle">
    <div class="itemTitle_left">
      <div class="TitleIcon" @click.stop="getData">
        <img src="../assets/home/icon_right.png" alt="">
      </div>
      <p>{{ title }}</p>
    </div>
    <div class="itemTitle_right">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: "titleInfo",
  components: {},
  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      status: ''
    }
  },
  watch: {},
  mounted() {
  },
  methods: {
    getData() {

      this.$emit('getHide', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.itemTitle {

  background: url("../assets/home/itemtitlebg.png") left center no-repeat;
  background-size: 197px 44px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  height: 44px;
  width: 100%;
  align-content: flex-start;
  position: relative;
  z-index: 11;


  .TitleIcon {
    width: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: flex-start;

    img {
      width: 14px;
    }
  }

  p {
    font-size: 18px;
    font-family: PingFang;
    font-weight: bold;
    color: #34DCFC;

    background: linear-gradient(0deg, #0344FF 0%, #05DCF8 80.126953125%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

.itemTitle_left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;
}
.itemTitle_right{
  z-index: 1000;
}
</style>
